<style scoped>
</style>

<template>
  <div style="background:#fff;padding:15px;">
    <Button
        @click="goRequestForm"
        type="success"
        v-if="runtime_role>1"
    >新增发布</Button>
    <Button
        style="margin-left:10px;"
        @click="loadAllRequest()"
        type="info"
    >刷新</Button>
    <Table
        stripe
        :columns="tdata.col_data"
        :data="tdata.current_data"
        :loading="tdata.loading"
        style="margin-top:10px"
      >
        <template
            slot-scope="{row}"
            slot="type"
            >
            <Tag v-if="row.type==1" color="green" >正式版本</Tag>
            <Tag v-if="row.type==2" color="orange" >sp版本</Tag>
        </template>
        <template
            slot-scope="{row}"
            slot="state"
            >
            <Tag v-if="row.state==0" color="geekblue" >待提交至审核</Tag>
            <Tag v-if="row.state==1" color="pink" >待审核</Tag>
            <Tag v-if="row.state==2" color="volcano" >审核中</Tag>
            <Tag v-if="row.state==3" color="red" >拒绝</Tag>
            <Tag v-if="row.state==4" color="success" >审核完成</Tag>
        </template>
        <template
            slot-scope="{row}"
            slot="updatedate"
            >
            {{ dayjs(new Date(row.updatedate)).format("YYYY-MM-DD HH:mm") }}
        </template>
        <template
            slot-scope="{row}"
          slot="operation"
        >
            <Button
                v-if="row.state==0"
                style="margin-left:10px;"
                size="small"
                type="info"
                @click="goRequestForm(row)"
                >修改</Button>
            <Button
                v-if="row.state==0"
                style="margin-left:10px;"
                size="small"
                    type="error"
                    @click="delRow(row)"
                >删除</Button>

            <Button
                v-if="(row.state==2||row.state==4)&&(runtime_role==2||runtime_role==3)"
                    style="margin-left:10px;"
                    size="small"
                    type="primary"
                    @click="detailRow(row, true)"
                >查看</Button>
            <Button
                v-if="(row.step == 0)&&(row.state==1)&&(runtime_role==2||runtime_role==3)"
                style="margin-left:10px;"
                size="small"
                    type="warning"
                    @click="revokeRow(row)"
                >撤销</Button>

            <Button
                v-if="(row.step==0)&&(row.state==1)&&(runtime_role==1||runtime_role==3)"
                    style="margin-left:10px;"
                    size="small"
                    type="primary"
                    @click="examineRow(row)"
                >开始审核</Button>
            <Button
                v-if="(row.state==2)&&(runtime_role==1||runtime_role==3)"
                    style="margin-left:10px;"
                    size="small"
                    type="primary"
                    @click="continueExamineRow(row)"
                >继续审核</Button>

            <Button
                v-if="(row.step!=0)&&((row.state==1)||(row.state==3))&&(runtime_role==1||runtime_role==3)"
                    style="margin-left:10px;"
                    size="small"
                    type="primary"
                    @click="detailRow(row, true)"
                >审阅</Button>

            <Button
                v-if="(row.state==3)&&(runtime_role==2||runtime_role==3)"
                style="margin-left:10px;"
                size="small"
                    type="primary"
                @click="goRequestForm(row, 'yes')"
                >修改</Button>

            <Button
                v-if="(row.step != 0)&&(row.state==1)&&(runtime_role==2||runtime_role==3)"
                    style="margin-left:10px;"
                    size="small"
                    type="primary"
                    @click="detailRow(row)"
                >修改</Button>

            <Button
                v-if="row.state==4"
                style="margin-left:10px;"
                size="small"
                    type="dashed"
                >测试报告</Button>
        </template>
      </Table>

      <div style="margin-top: 15px;margin-left: 15px;">
          <Page :total="tdata.total" ref="pagetool" @on-change="pagechange"  />
      </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  components: {
    
  },
  data() {
    return {
        runtime_role:0, //当前页面身份，如果是 3 即是开发者，也是管理者，2 表示开发者，1 发版专员
        tdata:{
            total:10,
            page:1,
            //是否显示loading框
            loading: false,
            //当前表格数据
            current_data: [
                {
                    id:"1",
                    name:"小程序V210",
                    version:"1.2.3",
                    buildcode:2023040511,
                    type:1,
                    state:0,
                }
            ],
            //表头数据
            col_data: [
                {
                    type: "index",
                    width: 60,
                    align: "center",
                },
                {
                    title: "组件名称",
                    key: "name",
                },
                {
                    title: "版本号",
                    key: "version",
                },
                {
                    title: "构建号",
                    key: "buildcode",
                },
                {
                    title: "发版类型",
                    key: "type",
                    slot: "type",
                },
                {
                    // 0 准备提交至审核
                    // 1 待审核
                    // 2 审核中
                    // 3 已拒绝
                    // 4 审核通过
                    title: "状态",
                    key: "state",
                    slot: "state",
                },
                {
                    title: "时间",
                    key: "updatedate",
                    slot: "updatedate",
                },
                {
                    title: "操作",
                    slot: "operation",
                },
            ],
        }
    };
  },
  methods: {
    dayjs,
    initRuntimeRole(){
        let user = this.getCurrentUserInfo();
        let flag = 0;
        if (user) {
            for (let item of user.roles) {
                if (item === "versiondeployer") {
                    if (flag == 2) {
                        flag = 3;
                    } else {
                        flag = 1;
                    }
                } else if (item === "developer") {
                    if (flag == 1) {
                        flag = 3;
                    } else {
                        flag = 2;
                    }
                }
            }
            this.runtime_role = flag;
        }
        this.loadAllRequest();
    },
    pagechange(page){
        this.tdata.page = page;
        this.loadAllRequest(page)
    },
    loadAllRequest(pagesize = 10){
        let _this = this;
        this.tdata.loading = true;
        this.$http.get({
            method: "mqms/moduledist/findallrequest",
            params:{
                page:this.tdata.page,
                pagesize:pagesize,
                role:this.runtime_role
            },
            success: function (data) {
                _this.tdata.loading = false;
                _this.tdata.current_data = data.list;
                _this.tdata.total = data.total;
            },
            failure(code, errMsg) {
                _this.tdata.loading = false;
                _this.$Message.error({
                    message:errMsg||"加载失败"
               })
            },
        });
    },

    goRequestForm(row, isExamine){
        if (row == null) {
            this.$router.push({
                name:"vreleasemanageformadd"
            });
        } else {
            this.$router.push({
                name:"vreleasemanageformupdate",
                params:{id:row.id, isExamine:isExamine}
            });
        }
    },





    delRow(row){
        let _this = this;
        this.$Modal.confirm({
            title: "提示",
            content: "确定要删除吗？",
            onOk: () => {
                _this.tdata.loading = true;
                _this.$http.post({
                    method: "mqms/moduledist/delrequest",
                    params: {
                        id:row.id
                    },
                    success: function (data) {
                        _this.tdata.loading = false;
                        _this.loadAllRequest();
                    },
                    failure(code, msg) {
                        _this.tdata.loading = false;
                        _this.$Message.error({
                            title: "提示",
                            content: msg,
                        });
                    },
                });
            },
        })
    },
    revokeRow(row) {
        let _this = this;
        this.$Modal.confirm({
            title: "提示",
            content: "确定要撤销吗？",
            onOk: () => {
                _this.tdata.loading = true;
                _this.$http.post({
                    method: "mqms/moduledist/revokerequestbyid",
                    params: {
                        id:row.id
                    },
                    success: function (data) {
                        _this.tdata.loading = false;
                        _this.loadAllRequest();
                    },
                    failure(code, msg) {
                        _this.tdata.loading = false;
                        _this.$Message.error({
                            title: "提示",
                            content: msg,
                        });
                    },
                });
            },
        })
    },
    detailRow(row, isonlyread) {
        if (isonlyread) {
            this.$router.push({
                name:"formrequestdetail",
                params:{id:row.id}
            })
        } else {
            this.$router.push({
                name:"vreleasemanageformupdate",
                params:{id:row.id, isExamine:'yes'}
            });
        }

      
    },
    examineRow(row){
        let _this = this;
        this.$Modal.confirm({
            title:"提示",
            content:"是否开始审核该条请求？",
            onOk:()=>{
                _this.tdata.loading = true;
                _this.$http.post({
                    method: "mqms/moduledist/examinerequetbyid",
                    params:{
                        id:row.id
                    },
                    success: function (data) {
                        _this.tdata.loading = false;
                        _this.$router.push({
                            name:"formrequestexamine",
                            params:{id:row.id}
                        });
                    },
                    failure(code, msg) {
                        _this.tdata.loading = false;
                        _this.$Message.error({
                            title: "提示",
                            content: msg,
                        });
                    },
                });
            }
        });
    },
    continueExamineRow(row){
        this.$router.push({
            name:"formrequestexamine",
            params:{id:row.id}
        }); 
    }
  },
  created() {
    this.initRuntimeRole();
  },
};
</script>